"use client";

import { c as _c } from "react/compiler-runtime";
import { ProfileActivityLog } from "@/entities/IProfile";
import { CountlessPage } from "@/helpers/Types";
import { commonApiFetch } from "@/services/api/common-api";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import CommonFilterTargetSelect from "../utils/CommonFilterTargetSelect";
import ProfileActivityLogsFilter from "./filter/ProfileActivityLogsFilter";
import ProfileActivityLogsList from "./list/ProfileActivityLogsList";
import { ProfileActivityFilterTargetType, ProfileActivityLogType, RateMatter } from "@/enums";
import { convertActivityLogParams } from "@/helpers/profile-logs.helpers";
import { selectActiveGroupId } from "@/store/groupSlice";
import { useSelector } from "react-redux";
import { QueryKey } from "../react-query-wrapper/ReactQueryWrapper";
import CommonCardSkeleton from "../utils/animation/CommonCardSkeleton";
import CommonTablePagination from "../utils/table/paginator/CommonTablePagination";
export interface ActivityLogParams {
  readonly page: number;
  readonly pageSize: number;
  readonly logTypes: ProfileActivityLogType[];
  readonly matter: RateMatter | null;
  readonly targetType: ProfileActivityFilterTargetType;
  readonly handleOrWallet: string | null;
  readonly groupId: string | null;
}
export interface ActivityLogParamsConverted {
  readonly page: string;
  readonly page_size: string;
  readonly log_type: string;
  include_incoming?: string;
  rating_matter?: string;
  profile?: string;
  target?: string;
  group_id?: string;
}
export default function ProfileActivityLogs(t0) {
  const $ = _c(65);
  const {
    initialParams,
    withFilters,
    disableActiveGroup: t1,
    children
  } = t0;
  const disableActiveGroup = t1 === undefined ? false : t1;
  const activeGroupId = useSelector(selectActiveGroupId);
  const [selectedFilters, setSelectedFilters] = useState(initialParams.logTypes);
  const [targetType, setTargetType] = useState(initialParams.targetType);
  const [currentPage, setCurrentPage] = useState(initialParams.page);
  let t2;
  if ($[0] !== initialParams.logTypes || $[1] !== initialParams.page || $[2] !== initialParams.targetType) {
    t2 = () => {
      setSelectedFilters(initialParams.logTypes);
      setTargetType(initialParams.targetType);
      setCurrentPage(initialParams.page);
    };
    $[0] = initialParams.logTypes;
    $[1] = initialParams.page;
    $[2] = initialParams.targetType;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== initialParams) {
    t3 = [initialParams];
    $[4] = initialParams;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== selectedFilters) {
    t4 = filter => {
      if (selectedFilters.includes(filter)) {
        setSelectedFilters(selectedFilters.filter(f => f !== filter));
      } else {
        setSelectedFilters([...selectedFilters, filter]);
      }
      setCurrentPage(1);
    };
    $[6] = selectedFilters;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const onFilter = t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = target => {
      setTargetType(target);
      setCurrentPage(1);
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const onTargetType = t5;
  let t6;
  if ($[9] !== activeGroupId || $[10] !== currentPage || $[11] !== disableActiveGroup || $[12] !== initialParams.handleOrWallet || $[13] !== initialParams.matter || $[14] !== initialParams.pageSize || $[15] !== selectedFilters || $[16] !== targetType) {
    t6 = convertActivityLogParams({
      params: {
        page: currentPage,
        pageSize: initialParams.pageSize,
        logTypes: selectedFilters,
        matter: initialParams.matter,
        targetType,
        handleOrWallet: initialParams.handleOrWallet,
        groupId: activeGroupId
      },
      disableActiveGroup: !!disableActiveGroup
    });
    $[9] = activeGroupId;
    $[10] = currentPage;
    $[11] = disableActiveGroup;
    $[12] = initialParams.handleOrWallet;
    $[13] = initialParams.matter;
    $[14] = initialParams.pageSize;
    $[15] = selectedFilters;
    $[16] = targetType;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const [params, setParams] = useState(t6);
  let t7;
  if ($[18] !== activeGroupId || $[19] !== currentPage || $[20] !== disableActiveGroup || $[21] !== initialParams.handleOrWallet || $[22] !== initialParams.matter || $[23] !== initialParams.pageSize || $[24] !== selectedFilters || $[25] !== targetType) {
    t7 = () => {
      setParams(convertActivityLogParams({
        params: {
          page: currentPage,
          pageSize: initialParams.pageSize,
          logTypes: selectedFilters,
          matter: initialParams.matter,
          targetType,
          handleOrWallet: initialParams.handleOrWallet,
          groupId: activeGroupId
        },
        disableActiveGroup: !!disableActiveGroup
      }));
    };
    $[18] = activeGroupId;
    $[19] = currentPage;
    $[20] = disableActiveGroup;
    $[21] = initialParams.handleOrWallet;
    $[22] = initialParams.matter;
    $[23] = initialParams.pageSize;
    $[24] = selectedFilters;
    $[25] = targetType;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== activeGroupId || $[28] !== currentPage || $[29] !== initialParams.handleOrWallet || $[30] !== selectedFilters || $[31] !== targetType) {
    t8 = [currentPage, selectedFilters, initialParams.handleOrWallet, targetType, activeGroupId];
    $[27] = activeGroupId;
    $[28] = currentPage;
    $[29] = initialParams.handleOrWallet;
    $[30] = selectedFilters;
    $[31] = targetType;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  useEffect(t7, t8);
  let t9;
  if ($[33] !== params) {
    t9 = {
      queryKey: [QueryKey.PROFILE_LOGS, {
        ...params
      }],
      queryFn: async () => await commonApiFetch({
        endpoint: "profile-logs",
        params
      }),
      placeholderData: keepPreviousData
    };
    $[33] = params;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  const {
    isLoading,
    data: logs
  } = useQuery(t9);
  let t10;
  if ($[35] !== isLoading || $[36] !== logs) {
    t10 = () => {
      if (isLoading) {
        return;
      }
      if (logs?.page === 1 && !logs.data.length) {
        setCurrentPage(1);
      }
    };
    $[35] = isLoading;
    $[36] = logs;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  const t11 = logs?.page;
  let t12;
  if ($[38] !== isLoading || $[39] !== t11) {
    t12 = [t11, isLoading];
    $[38] = isLoading;
    $[39] = t11;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  useEffect(t10, t12);
  const t13 = `${initialParams.handleOrWallet ? "" : "tw-mt-2"}  `;
  let t14;
  if ($[41] !== children) {
    t14 = children && <div>{children}</div>;
    $[41] = children;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== children || $[44] !== initialParams.handleOrWallet || $[45] !== initialParams.logTypes || $[46] !== onFilter || $[47] !== selectedFilters || $[48] !== withFilters) {
    t15 = withFilters && <div className="min-[1200px]:tw-flex min-[1200px]:tw-justify-end"><div className={`${children ? "" : "tw-mt-6"} min-[1200px]:tw-w-80`}><ProfileActivityLogsFilter user={initialParams.handleOrWallet} options={initialParams.logTypes} selected={selectedFilters} setSelected={onFilter} /></div></div>;
    $[43] = children;
    $[44] = initialParams.handleOrWallet;
    $[45] = initialParams.logTypes;
    $[46] = onFilter;
    $[47] = selectedFilters;
    $[48] = withFilters;
    $[49] = t15;
  } else {
    t15 = $[49];
  }
  let t16;
  if ($[50] !== t14 || $[51] !== t15) {
    t16 = <div className="tw-w-full tw-flex tw-flex-col min-[1200px]:tw-flex-row tw-gap-y-4 min-[1200px]:tw-gap-x-16 min-[1200px]:tw-justify-between min-[1200px]:tw-items-center">{t14}{t15}</div>;
    $[50] = t14;
    $[51] = t15;
    $[52] = t16;
  } else {
    t16 = $[52];
  }
  let t17;
  if ($[53] !== initialParams.handleOrWallet || $[54] !== targetType) {
    t17 = initialParams.handleOrWallet && <CommonFilterTargetSelect selected={targetType} onChange={onTargetType} />;
    $[53] = initialParams.handleOrWallet;
    $[54] = targetType;
    $[55] = t17;
  } else {
    t17 = $[55];
  }
  let t18;
  if ($[56] !== currentPage || $[57] !== initialParams.handleOrWallet || $[58] !== logs) {
    t18 = logs ? <div>{logs?.data.length ? <div className="tw-flow-root tw-scroll-py-3 tw-overflow-y-auto tw-overflow-x-auto tw-scrollbar-thin tw-scrollbar-thumb-iron-500 tw-scrollbar-track-iron-800 desktop-hover:hover:tw-scrollbar-thumb-iron-300"><ProfileActivityLogsList logs={logs.data} user={initialParams.handleOrWallet} /><CommonTablePagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={null} haveNextPage={logs.next} small={!!initialParams.handleOrWallet} /></div> : <div className="tw-py-4"><span className={`${initialParams.handleOrWallet ? "tw-px-4 sm:tw-px-6" : ""} tw-text-sm sm:tw-text-md tw-italic tw-text-iron-500`}>No Activity Log</span></div>}</div> : <div className="tw-h-screen tw-w-full"><CommonCardSkeleton /></div>;
    $[56] = currentPage;
    $[57] = initialParams.handleOrWallet;
    $[58] = logs;
    $[59] = t18;
  } else {
    t18 = $[59];
  }
  let t19;
  if ($[60] !== t13 || $[61] !== t16 || $[62] !== t17 || $[63] !== t18) {
    t19 = <div className={t13}>{t16}{t17}{t18}</div>;
    $[60] = t13;
    $[61] = t16;
    $[62] = t17;
    $[63] = t18;
    $[64] = t19;
  } else {
    t19 = $[64];
  }
  return t19;
}